<div [ngClass]="{ 'form-row': to?.className === 'xilo-input' }">
  <div [ngClass]="{ 'form-item': to?.className === 'xilo-input' }">
    <label *ngIf="to.label">
      {{ to.label }}
      <span *ngIf="to?.required" class="required-indicator">*</span>
    </label>
    <input
      [class]="to.className || 'xilo-input'"
      type="text"
      [ngClass]="
        changeInputCSS(formControl.invalid, formControl.touched, to.className)
      "
      [formControl]="formControl"
      [formlyAttributes]="field"
      (blur)="handleBlur($event)"
    />
    <label
      class="invalid-feedback"
      *ngIf="formControl.touched && formControl.invalid"
    >
      This field is required.
    </label>
  </div>
</div>
